@if (loadedError) {
  <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
  <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (loaded) {
  <div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
      @if (!noTitle) {
        <h1 class="widget-title align-self-center">
          {{ 'web.widget_cards' | translate }}
        </h1>
      }
      <div class="d-flex">
        @if (data?.home; as p) {
          <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
            <div class="widget-team__name d-flex align-items-center">
              <img
                (error)="imageError($event)"
                [alt]="p.name"
                [attr.src]="p.image | responsive : 'participant' : 'medium'"
                class="img-fluid app-cursor mr-1"
                />
              <div>{{ p.name }}</div>
            </div>
          </div>
        }
        @if (data?.away; as p) {
          <div
            class="widget-team mt-1 d-flex flex-column widget-team--second"
            data-cy="team"
            >
            <div class="widget-team__name d-flex align-items-center justify-content-end">
              <div>{{ p.name }}</div>
              <img
                (error)="imageError($event)"
                [alt]="p.name"
                [attr.src]="p.image | responsive : 'participant' : 'medium'"
                class="img-fluid app-cursor ml-1"
                />
            </div>
          </div>
        }
      </div>
      <!-- Cards total -->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">
            &nbsp;
          </div>
          <div class="widget-form-participant-text font-weight-bold font-1-1x">
            {{ 'web.avg_cards_total' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">
            &nbsp;
          </div>
        </div>
        <div class="d-flex justify-content-around">
          <app-chart-circle-somple [percentage]="homeWidth('total')" [text]="data?.home?.name">
            @if (cards('home', 'total') !== 'Ndf') {
              {{
              cards('home', 'total') | number : '1.0-1'
              }}
            }
            @if (cards('home', 'total') === 'Ndf') {
              {{
              cards('home', 'total')
              }}
            }
          </app-chart-circle-somple>
          <app-chart-circle-somple [percentage]="awayWidth('total')" [text]="data?.away?.name">
            @if (cards('away', 'total') !== 'Ndf') {
              {{
              cards('away', 'total') | number : '1.0-1'
              }}
            }
            @if (cards('away', 'total') === 'Ndf') {
              {{
              cards('away', 'total')
              }}
            }
          </app-chart-circle-somple>
        </div>
      </div>
      <!-- Corners yellow-->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome"></div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.avg_cards_yellow' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway"></div>
        </div>
        <div class="d-flex">
          <div
            [style.width.%]="homeWidth('yellow')"
            class="widget-form-participant-bar widget-form-participant-bar--home"
            >
            @if (cards('home', 'yellow') !== 'Ndf') {
              {{
              cards('home', 'yellow') | number : '1.0-1'
              }}
            }
          </div>
          <div
            [style.width.%]="awayWidth('yellow')"
            class="widget-form-participant-bar widget-form-participant-bar--away"
            >
            @if (cards('away', 'yellow') !== 'Ndf') {
              {{
              cards('away', 'yellow') | number : '1.0-1'
              }}
            }
          </div>
        </div>
      </div>
      <!-- Cards red-->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome"></div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.avg_cards_red' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway"></div>
        </div>
        <div class="d-flex">
          <div
            [style.width.%]="homeWidth('red')"
            class="widget-form-participant-bar widget-form-participant-bar--home"
            >
            @if (cards('home', 'yellow') !== 'Ndf') {
              {{
              cards('home', 'red') | number : '1.0-1'
              }}
            }
          </div>
          <div
            [style.width.%]="awayWidth('red')"
            class="widget-form-participant-bar widget-form-participant-bar--away"
            >
            @if (cards('away', 'yellow') !== 'Ndf') {
              {{
              cards('away', 'red') | number : '1.0-1'
              }}
            }
          </div>
        </div>
      </div>
      <div class="hr-widget">&nbsp;</div>
      <!-- Cards total sum-->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">
            &nbsp;
          </div>
          <div class="widget-form-participant-text font-weight-bold font-1-1x">
            {{ 'web.avg_cards_total_sum' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">
            &nbsp;
          </div>
        </div>
        <div class="d-flex justify-content-around">
          <app-chart-circle-somple [percentage]="homeWidth('total', true)" [text]="data?.home?.name">
            @if (cards('home', 'total', true) !== 'Ndf') {
              {{
              cards('home', 'total', true) | number : '1.0-1'
              }}
            }
            @if (cards('home', 'total', true) === 'Ndf') {
              {{
              cards('home', 'total', true)
              }}
            }
          </app-chart-circle-somple>
          <app-chart-circle-somple [percentage]="awayWidth('total', true)" [text]="data?.away?.name">
            @if (cards('away', 'total', true) !== 'Ndf') {
              {{
              cards('away', 'total', true) | number : '1.0-1'
              }}
            }
            @if (cards('away', 'total', true) === 'Ndf') {
              {{
              cards('away', 'total', true)
              }}
            }
          </app-chart-circle-somple>
        </div>
      </div>
      <!-- Corners yellow sun-->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome"></div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.avg_cards_yellow_sum' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway"></div>
        </div>
        <div class="d-flex">
          <div
            [style.width.%]="homeWidth('yellow', true)"
            class="widget-form-participant-bar widget-form-participant-bar--home"
            >
            @if (cards('home', 'yellow') !== 'Ndf') {
              {{
              cards('home', 'yellow', true) | number : '1.0-1'
              }}
            }
          </div>
          <div
            [style.width.%]="awayWidth('yellow', true)"
            class="widget-form-participant-bar widget-form-participant-bar--away"
            >
            @if (cards('away', 'yellow') !== 'Ndf') {
              {{
              cards('away', 'yellow', true) | number : '1.0-1'
              }}
            }
          </div>
        </div>
      </div>
      <!-- Cards red sum-->
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome"></div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.avg_cards_red_sum' | translate }}
          </div>
          <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway"></div>
        </div>
        <div class="d-flex">
          <div
            [style.width.%]="homeWidth('red', true)"
            class="widget-form-participant-bar widget-form-participant-bar--home"
            >
            @if (cards('home', 'yellow') !== 'Ndf') {
              {{
              cards('home', 'red', true) | number : '1.0-1'
              }}
            }
          </div>
          <div
            [style.width.%]="awayWidth('red', true)"
            class="widget-form-participant-bar widget-form-participant-bar--away"
            >
            @if (cards('away', 'yellow') !== 'Ndf') {
              {{
              cards('away', 'red', true) | number : '1.0-1'
              }}
            }
          </div>
        </div>
      </div>
      <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
        {{ 'web.num_of_matches' | translate }} ({{ num }})
      </div>
      <div class="widget-logo d-flex justify-content-center mt-4">
        <img
          [alt]="client.getName()"
          [src]="'/img/' + client.getName() + '.png'"
          class="widget-logo-client"
          data-cy="logo"
          />
      </div>
    </div>
  </div>
}
